import { cva } from 'class-variance-authority';

export const cvaItem = cva(['FiltersGroupStyles-cvaRoot', 'not-last:mb-1.6 sm:not-last:mb-0', 'py-0.3 sm:py-0']);

export const cvaItemHeader = cva([
  'FiltersGroupStyles-cvaItemHeader',
  'flex items-center justify-between',
  'relative',
  'sm:py-1.2 sm:pr-2.4',
  'cursor-pointer select-none',
  'rounded-[1.6rem]',
  'transition-colors duration-300',
  'sm:hover:bg-cMediumGreyOnWhite',
  'group',
]);

export const cvaItemHeaderArrow = cva(
  [
    'FiltersGroupStyles-cvaItemHeaderArrow',
    'absolute right-0 sm:right-auto sm:left-0 sm:top-0.4',
    'w-1.6 h-1.6',
    'stroke-cBlack',
    'transition-transform duration-300',
  ],
  {
    variants: {
      active: {
        true: ['-rotate-90 sm:-rotate-180'],
        false: ['-rotate-90 sm:-rotate-0'],
      },
      hasReset: {
        true: ['hidden sm:block'],
        false: [''],
      },
    },
    defaultVariants: {
      active: false,
      hasReset: false,
    },
  }
);

export const cvaItemHeaderInner = cva(
  [
    'FiltersGroupStyles-cvaItemHeaderInner',
    'flex items-center gap-0.8 sm:gap-0',
    'sm:relative',
    'sm:pl-2.4',
    'transition-transform duration-300',
    'sm:group-hover:translate-x-2.4',
  ],
  {
    variants: {
      active: {
        true: ['sm:translate-x-2.4'],
        false: [''],
      },
    },
    defaultVariants: {
      active: false,
    },
  }
);

export const cvaItemHeaderTitle = cva([
  'FiltersGroupStyles-cvaItemHeaderTitle',
  'flex items-center gap-0.8',
  'text-bodyM',
  '[&>span]:text-[#213D38]',
]);

export const cvaItemHeaderBadge = cva([
  'FiltersGroupStyles-cvaItemHeaderBadge',
  'relative sm:-left-0.4 sm:-top-0.2',
  'w-1.6 h-1.6',
  'text-bodyXXS text-cWhite text-center',
  'bg-cMediumGreen',
  'rounded-full border-[0.14rem] border-cWhite',
]);

export const cvaReset = cva([
  'FiltersGroupStyles-cvaReset',
  'inline-block',
  'text-bodyXS text-cBlack48',
  'cursor-pointer select-none',
  'py-0.3',
  'border-b-[0.1rem] border-cBlack48',
]);

export const cvaResetMobile = cva(['FiltersGroupStyles-cvaResetMobile', 'absolute top-1.2 right-2.4']);

export const cvaItemWrapper = cva(['FiltersGroupStyles-cvaItemWrapper', 'relative overflow-hidden']);

export const cvaItemContent = cva(['FiltersGroupStyles-cvaItemContent', 'py-2.4']);

export const cvaMobileFilters = cva([
  'FiltersGroupStyles-cvaMobileFilters',
  'flex flex-col',
  'absolute left-0 top-0 z-[10]',
  'w-full h-full',
  'bg-cWhite',
]);

export const cvaClose = cva([
  'FiltersGroupStyles-cvaClose',
  'flex items-center justify-center',
  'absolute top-1.2 sm:top-4 right-2.4 sm:right-[46.7rem] z-[10]',
  'w-2.4 sm:w-5.6 h-2.4 sm:h-5.6',
  'sm:bg-cWhite',
  'rounded-[1.6rem]',
  'cursor-pointer select-none',
]);

export const cvaCloseIcon2 = cva([
  'FiltersGroupStyles-cvaCloseIcon2',
  'sm:hidden',
  'w-2.4 sm:w-1.6 h-2.4 sm:h-1.6',
  'fill-cBlack',
]);

export const cvaBack = cva([
  'FiltersGroupStyles-cvaBack',
  'absolute top-1.2 left-2.4 z-[2]',
  'sm:hidden',
  'w-2.4 sm:w-1.6 h-2.4 sm:h-1.6',
]);

export const cvaBackIcon = cva(['FiltersGroupStyles-cvaBackIcon', 'w-2.4 sm:w-1.6 h-2.4 sm:h-1.6', 'fill-cBlack']);

export const cvaMobileFiltersHeader = cva([
  'FiltersGroupStyles-cvaMobileFiltersHeader',
  'relative',
  'p-1.4',
  'bg-cLightGrey',
]);

export const cvaMobileFiltersHeaderTitle = cva([
  'FiltersGroupStyles-cvaMobileFiltersHeaderTitle',
  'text-labelL text-center uppercase',
]);

export const cvaMobileFiltersBody = cva([
  'FiltersGroupStyles-cvaMobileFiltersBody',
  'flex-grow flex-1',
  'overflow-auto',
  'py-3.2 px-2.4 pb-[12rem]',
]);

export const cvaMobileFiltersFooter = cva([
  'FiltersGroupStyles-cvaMobileFiltersFooter',
  'absolute left-0 bottom-0 z-[10]',
  'w-full',
  'p-2.4 pt-1.6 pb-3.6',
  'bg-cWhite',
  'rounded-[3.2rem] rounded-br-none rounded-bl-none',
  '[box-shadow:0_0_5.6rem_0_rgba(33,_61,_56,_0.12)]',
]);

export const cvaMobileFiltersFooterButton = cva([
  'FiltersGroupStyles-cvaMobileFiltersFooterButton',
  'block w-full',
  'px-2.4',
  'text-bodyM',
]);
